import { create } from "zustand";
import { URL } from "../lib/apis";

interface CartState {
  prodDetail: any | null; // Initialise à null pour éviter les erreurs au chargement
  loadingDetail: boolean;
  fetchprodDetail: (prod_id: string) => Promise<void>;
}

const useprodDetail = create<CartState>((set) => ({
  prodDetail: null, // Initialise à null avant le chargement des données
  loadingDetail: false,

  fetchprodDetail: async (prod_id: string) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user");

    // if (!token) {
    //   console.error("User is not authenticated");
    //   return;
    // }

    set({ loadingDetail: true });

    try {
      const response = await fetch(
        `${URL}/products/${prod_id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch categories: ${response.statusText}`);
      }

      const data = await response.json();
      set({ prodDetail: data.product, loadingDetail: false }); // On assigne directement 'data' sans 'data.data'
    } catch (error) {
      if (error instanceof Error) {
        console.error("Error fetching categories:", error.message);
      } else {
        console.error("Unknown error occurred");
      }
      set({ loadingDetail: false });
    }
  },
}));

export default useprodDetail;
